import { createContext, useContext, useState, useEffect } from 'react';

const PlayerContext = createContext(null);

export const usePlayerStore = () => {
    const context = useContext(PlayerContext);
    if (!context) {
        throw new Error('usePlayerStore는 PlayerProvider 내에서 사용되어야 합니다.');
    }
    return context;
};

export const PlayerProvider = ({ children }) => {
    const [players, setPlayers] = useState(null); 
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('/baseball_output.json');
                
                if (!response.ok) {
                    throw new Error(`HTTP 오류: ${response.status}`);
                }
                
                const data = await response.json();
                setPlayers(data);
            } catch (err) {
                console.error("선수 데이터 로딩 중 오류 발생:", err);
                setError(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    const store = {
        playersData: players,
        setPlayersData: setPlayers,
        isLoading,
        error,
    };

    if (isLoading) {
        return <div>데이터를 불러오는 중입니다...</div>;
    }
    
    if (error) {
        return <div>데이터 로드에 실패했습니다. 잠시 후 다시 시도해주세요.</div>;
    }


    return (
        <PlayerContext.Provider value={store}>
            {children}
        </PlayerContext.Provider>
    );
};